import Mustache from 'mustache';
import proxyData from 'mustache-validator';

/**
 * Very similar to Mustache.render(..) but will return undefined if any of the template parameters are missing.
 *
 * This means that we don't do things like redirect users to `https://example.org//bar=` for `https://example.org/{{foo}}/bar={{bar}}`
 *
 * @param {string} template
 * @param {Record<string, any>} params
 * @returns {string | undefined}
 */
export function renderMustacheTemplateIfAllTemplateParametersArePresent(template, params) {
  let anyFieldsMissing = false;
  const result = Mustache.render(
    template,
    proxyData(params, {
      handleError(invalidPropertyPathSegments) {
        console.log(
          `Mustache template parameter missing: ${invalidPropertyPathSegments.join('.')}`
        );
        anyFieldsMissing = true;
      },
    })
  );

  if (anyFieldsMissing) {
    return undefined;
  }
  return result;
}
